import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';

@Injectable()
export class TestimonialsQueryService {
  private CREATE_TESTIMONIAL_DATA: any;
  private GET_ALL_TESTIMONIAL_DATA: any;
  private DELETE_TESTIMONIAL_DATA: any;

  constructor(public apollo: Apollo) {

    //Create testimonial  detail
    this.CREATE_TESTIMONIAL_DATA = gql` 
      mutation CREATE_TESTIMONIAL($input:CreateTestimonialInput!){
        createTestimonial(input: $input){
          testimonial{
            nodeId
            id
            personpicurl
            createdat
            quotes
          }
        }
      }
    `;


    this.GET_ALL_TESTIMONIAL_DATA = gql`
            query{
                allTestimonials(orderBy:CREATEDAT_DESC) {
    
                    nodes {
                        nodeId
                            createdat
                                id
                        personpicurl
                        quotes
                        }
                }
            }
        `;


    this.DELETE_TESTIMONIAL_DATA = gql`
        mutation DELETE_TESTIMONIAL_DATA($input:DeleteTestimonialByIdInput!){
                deleteTestimonialById(input:$input){
                  deletedTestimonialId
                }
            }
        `;

  }

  //Upload testimonial datas
  UPLOAD_TESTIMONIAL(fileName, quotes) {
    return this.apollo.mutate({
      mutation: this.CREATE_TESTIMONIAL_DATA,
      variables: {
        "input": {
          "testimonial": {
            "personpicurl": fileName,
            "quotes": quotes,
            "createdat": new Date(),
          }
        }
      },
    })
  }

  // GET All TESTIMONIAL
  GET_ALL_TESTIMONIAL() {
    return this.apollo.watchQuery({
      query: this.GET_ALL_TESTIMONIAL_DATA,
      fetchPolicy: 'network-only'
    })
  }

  //Delete Selected testimonial data
  DELETE_TESTIMONIAL(testimonialId) {
    return this.apollo.mutate({
      mutation: this.DELETE_TESTIMONIAL_DATA,
      variables: {
        "input": {
          "id": testimonialId
        }
      }
    })
  }

}


// WEBPACK FOOTER //
// I:/1.speKwo/New Spekwo Revamp/admindash/src/app/main/content/apps/queryFiles/testimonial.ts